import { isEqual } from 'lodash/fp';
import { DateTime } from 'luxon';

import { DEFAULT_PAGE_SIZE } from 'dashboard/lib/constants/pagination';
import { TableState } from 'dashboard/lib/interfaces/TableState';
import { UserAuditLog } from 'dashboard/models/user-audit-log';
import {
  UserAuditLogsActions,
  UserAuditLogsActionType,
  UserAuditLogsFilterParams,
} from 'dashboard/redux/actions/user-audit-logs';

export interface UserAuditLogsState
  extends Omit<TableState<UserAuditLogsFilterParams>, 'sortParams'> {
  userAuditLogs: UserAuditLog[];
}

export const getAuditLogsInitialState = (): UserAuditLogsState => {
  const currentTime = DateTime.local();
  return {
    userAuditLogs: [],
    paginationParams: undefined,
    filters: {
      omni: '',
      createdAtStart: currentTime.minus({ weeks: 2 }).startOf('day').toISO(),
      createdAtEnd: currentTime.endOf('day').toISO(),
      userId: undefined,
      methods: [],
    },
    pageSize: DEFAULT_PAGE_SIZE,
    currentPage: 1,
  };
};

export default (
  state: UserAuditLogsState = getAuditLogsInitialState(),
  action: UserAuditLogsActions,
) => {
  switch (action.type) {
    case UserAuditLogsActionType.SetUserAuditLogs: {
      return {
        ...state,
        userAuditLogs: action.payload.userAuditLogs,
        paginationParams: action.payload.paginationParams,
      };
    }

    case UserAuditLogsActionType.SetFilters: {
      const newFilters = {
        ...state.filters,
        ...action.payload.filters,
      };

      if (isEqual(newFilters, state.filters)) {
        return state;
      } else {
        return {
          ...state,
          filters: newFilters,
        };
      }
    }

    case UserAuditLogsActionType.SetPageSize: {
      return {
        ...state,
        pageSize: action.payload.pageSize,
      };
    }

    case UserAuditLogsActionType.SetCurrentPage: {
      return {
        ...state,
        currentPage: action.payload.currentPage,
      };
    }

    default:
      return state;
  }
};
